import React, { Component } from "react";
import Layout from "./components/layout";
import CharacterGenerator from "./views/character-generator";
import { GET_CHARACTERS_TOTAL, GET_CHARACTER } from "./requests";
import { withApollo } from "react-apollo";
import History from "./views/history/";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalOfCharacters: 0,
      character: null,
      history: [],
      loadingCharacter: false
    };
  }

  componentDidMount = async () => {
    const { client } = this.props;
    const {
      data: {
        characters: {
          info: { count: totalOfCharacters }
        }
      }
    } = await client.query({
      query: GET_CHARACTERS_TOTAL
    });
    this.setState({
      totalOfCharacters
    });
  };

  requestCharacter = async () => {
    this.setState({ loadingCharacter: true });
    const { client } = this.props;
    const { totalOfCharacters, history } = this.state;
    const randomId = Math.ceil(Math.random() * totalOfCharacters);
    const {
      data: { character }
    } = await client.query({
      query: GET_CHARACTER,
      variables: { id: randomId }
    });
    this.setState({
      character,
      history: [character, ...history]
    });
    this.setState({ loadingCharacter: false });
  };

  selectCharacter = id => {
    const { history } = this.state;

    this.setState({
      character: history[id]
    });

    window.scrollTo(0, 0);
  };

  render() {
    const { loadingCharacter, character, history } = this.state;
    return (
      <Layout>
        <CharacterGenerator
          loading={loadingCharacter}
          character={character}
          requestCharacter={this.requestCharacter}
        />
        {history.length > 0 && (
          <History selectCharacter={this.selectCharacter} history={history} />
        )}
      </Layout>
    );
  }
}

export default withApollo(App);
